import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-gradient-to-r from-[#1a0533] to-[#2d1052] py-16 px-4 border-y border-[#a855f7]/30" data-id="element-55">
      <div className="max-w-3xl mx-auto text-center flex flex-col items-center" data-id="element-56">
        <ShieldCheckIcon className="w-20 h-20 text-[#FFD700] mb-6" data-id="element-57" />
        <h3 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-58">
          🔒 Garantía de satisfacción de 7 días
        </h3>
        <p className="text-xl text-[#c4b5d4] mb-4 leading-relaxed" data-id="element-59">
          Si el curso no cumple tus expectativas, podés solicitar la devolución
          dentro de los primeros 7 días.
        </p>
        <p className="text-2xl font-bold text-[#FFD700]" data-id="element-60">
          Tu compra es 100% segura.
        </p>
      </div>
    </section>;
}